import { render, staticRenderFns } from "./AdminMessageHistorySection.vue?vue&type=template&id=063f1a50"
import script from "./AdminMessageHistorySection.vue?vue&type=script&lang=js"
export * from "./AdminMessageHistorySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports